/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "SalesExpDashboardApi",
            "endpoint": "https://42yvkbil65.execute-api.us-west-2.amazonaws.com/staging",
            "region": "us-west-2"
        }
    ]
};


export default awsmobile;
